import {useLexicalComposerContext} from '@lexical/react/LexicalComposerContext';
import {ImageNode} from 'components/DSYS/editor/nodes/ImageNode';
import {isAllowedCommentImageSrc} from 'helpers/commentContent';
import {useEffect} from 'react';

export const DisallowImagesPlugin = () => {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    if (!editor.hasNodes([ImageNode])) {
      return;
    }

    return editor.registerNodeTransform(ImageNode, (node) => {
      if (!isAllowedCommentImageSrc(node.getSrc())) {
        node.remove();
      }
    });
  }, [editor]);

  return null;
};
